
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";

interface BookingHelpCardProps {
  onContactSupport: () => void;
}

export const BookingHelpCard = ({ onContactSupport }: BookingHelpCardProps) => {
  return (
    <Card className="border shadow-sm bg-card">
      <CardContent className="p-6">
        <h3 className="font-semibold text-foreground mb-3">Need Help?</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Having trouble with your session? Our support team is here to help.
        </p>
        <Button 
          variant="outline" 
          size="sm" 
          className="w-full"
          onClick={onContactSupport}
        >
          <Mail className="h-4 w-4 mr-2" />
          Contact Support
        </Button>
      </CardContent>
    </Card>
  );
};
